import { SDK } from './sdk';
import type { Reducers } from '@sda/enums/store';
import type { FirestoreClientData, QueryFilterMask } from '../interfaces';
import type FirebaseFirestore from 'firebase/firestore';

interface ApiOptions<T = any> {
  readonly documentId?: string;
  readonly reducerName?: Reducers | ((item: T) => Reducers);
  readonly mask?: QueryFilterMask;
}

export interface ExtendedSDKClass<T> extends SDK<T> {
  getCollection?: (id: string) => SDK<T>;
}

/**
 *
 * @param  {any} clientData
 * @param  {FirebaseFirestore.CollectionReference} collection
 * @param  {any} options
 * @return {FirestoreBaseClass}
 */
export const SDKFactory = <T>(
  clientData: FirestoreClientData,
  collection: FirebaseFirestore.CollectionReference<T>,
  options: ApiOptions<T> = {},
): ExtendedSDKClass<T> => {
  const { documentId, reducerName, mask } = options;

  class ExtendedClass extends SDK<T> implements ExtendedSDKClass<T> {
    constructor(apiClient: FirestoreClientData) {
      super(apiClient, reducerName);

      this.collection = collection;

      if (documentId) {
        this.documentId = documentId;
      }

      if (mask) {
        this.PublicMap = mask;
      }
    }

    /**
     * Retrieves a subcollection by name from an object by id
     * @param  {string} id
     * @param  {string} collectionName
     * @param  {FirestoreBaseClass} [baseClass]
     * @return {FirestoreBaseClass}
    */
    getCollection(
      collectionName: string,
    ): SDK<T> {
      const subcollection = this.fsh.getCollection<T>(this.collection, documentId, collectionName);

      return SDKFactory<T>(clientData, subcollection);
    }
  }

  return new ExtendedClass(clientData);
};
